// Loader.js
import React from "react";
import "./style.css";

const Loader = (props) => {
  return (
    <div className="loader-overlay">
      <div className="loader-box">
        <span className="loading-text">{props.message}<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></span>
      </div>
    </div>
  );
};

export default Loader;
